module.exports = __webpack_public_path__ + "img/one_img_orange_tag_desktop_v1.6bad8a0.svg";